import React, { Component } from 'react';
import { formatBMK } from '../../../../../../models/market-map/data-parser';
import './index.css';


class Footer extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    const { dataSource } = this.props;
    //console.log('dataSource footer ----- ',dataSource)

    return (
      <div className='sc-market-map-footer'>
        <div className='sc-market-map-footer-left-sec'>
          <span>BourseView.com</span>
          <div>Total : { dataSource.total ? formatBMK(dataSource.total) : '' }</div>
        </div>
        <ul className='sc-market-map-footer-right-sec'>
          <li>-3%</li>
          <li>-2%</li>
          <li>-1%</li>
          <li>0%</li>
          <li>1%</li>
          <li>2%</li>
          <li>3%</li>
        </ul>
      </div>
    );
  }
}




export default Footer;




